/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import moment from '../../../lib/moment'
import bindActionCreators from '../../../lib/utils/bindActionCreators'

import { ppsSelector } from '../../../selectors'
import { ppsAction } from '../../../actions'

import MonthSelector from '../../../components/project-profit-sheet/MonthSelector'

/**
 * @typedef {object} Props
 * @property {typeof ppsAction.fetchProfitData} fetchProfitData
 * @property {typeof ppsAction.setSubmitMonth} setMonth
 * @property {string} projectID
 * @property {import('moment').Moment} startDate
 * @property {import('moment').Moment} month
 */

/**
 * @extends {React.Component<Props, *>}
 */
class MonthSelectorContainer extends React.Component {
  /**
   * @param {import('moment').Moment} month
   */
  handleSelectMonth = month => () => {
    const access_token = localStorage.getItem('access_token')
    const { projectID, fetchProfitData, setMonth, fetchProjectProgress, percentTab } = this.props

    setMonth(month)
    if (percentTab) {
      fetchProfitData(projectID, month, access_token)
      fetchProjectProgress(projectID, moment(month).startOf('month').format('YYYY-MM-DD'), access_token)
    } else {
      fetchProfitData(projectID, month, access_token)
    }
  }

  render = () => {
    const thisMonth = moment().startOf('month')
    const lastMonth = moment(this.props.month).subtract(1, 'month')
    const nextMonth = moment(this.props.month).add(1, 'month')

    return (
      <MonthSelector
        { ...this.props }
        currentMonth={ this.props.month.format('MMMM YYYY') }
        clickToday={ this.handleSelectMonth(thisMonth) }
        clickLastMonth={ this.handleSelectMonth(lastMonth) }
        clickNextMonth={ this.handleSelectMonth(nextMonth) }
        disableToday={ moment().isBefore(this.props.startDate, 'months') }
        disableLastMonth={ lastMonth.isBefore(this.props.startDate, 'months') }
      />
    )
  }
}

const mapStateToProps = createStructuredSelector({
  projectID: ppsSelector.projectID,
  startDate: ppsSelector.startDate,
  month: ppsSelector.submitMonth,
})

const mapDispatchToProps = bindActionCreators({
  fetchProfitData: ppsAction.fetchProfitData,
  fetchProjectProgress: ppsAction.fetchProjectProgress,
  setMonth: ppsAction.setSubmitMonth,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonthSelectorContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/MonthSelectorContainer.js